import Cartesian from './cartesian'
import Polar from './polar'

export default types => {
  // Right now we only have polar axes and cartesian.
  if (types.length === 1 && types[0] === 'polar') {
    return Polar
  } else {
    return Cartesian
  }
}
